import React from 'react';
import styles from '../../../styles/DocumentManagement.module.css';
import DocumentSubcategoryItem from './DocumentSubcategoryItem';

interface DocumentSubcategoriesListProps {
  subcategories: any[];
  categoryStats?: any;
  // Flag to indicate if this is company mode
  isCompanyMode?: boolean;
}

const DocumentSubcategoriesList: React.FC<DocumentSubcategoriesListProps> = ({ 
  subcategories, 
  categoryStats, 
  isCompanyMode = false
}) => {
  return (
    <div className={styles.categoriesContainer}>
      {subcategories.map(sub => (
        <div key={sub.id} className={styles.w100}>
          <DocumentSubcategoryItem 
            subcategory={sub} 
            stats={categoryStats?.subcategories?.[sub.id]}
            isCompanyMode={isCompanyMode}
          />
        </div>
      ))}
    </div>
  );
};

export default DocumentSubcategoriesList;
